import type { RiskGapModel } from '@ctw/shared/api/fhir/models/risk-opportunity';
import { ContentCard } from '@ctw/shared/components/containers/content-card';
import { useResourceDrawer } from '@ctw/shared/hooks/use-resource-drawer';
import { tw } from '@ctw/shared/utils/tailwind';

export function useRiskGapDrawer() {
  return useResourceDrawer({
    resourceType: 'MeasureReport',
    action: ({ model }: { model: RiskGapModel }) => ({
      label: 'Risk Gap',
      title: model.title,
      badges: [],
      content: {
        body: (
          <div className={tw`flex flex-col gap-5`}>
            <ContentCard variant="focal" title="Details">
              TODO
            </ContentCard>
          </div>
        ),
      },
    }),
  });
}
